import { render, staticRenderFns } from "./CsvCopy.vue?vue&type=template&id=2fd81042"
import script from "./CsvCopy.vue?vue&type=script&lang=js"
export * from "./CsvCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports